// src/components/Layout.js
import React, { useState, useEffect } from "react";
import Header from "./Header.js";
import Sidebar from "./Sidebar.js";
import { apiFetch } from "../api.js";
import "../styles/Dashboard.css"; // reuse your CSS

const Layout = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [menuData, setMenuData] = useState([]);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  // Fetch sidebar menu items once
  useEffect(() => {
    apiFetch("/api/menus")
      .then((res) => res.json())
      .then((data) => {
        console.log("🔥 MENU FROM API:", data);
        setMenuData(data);
      })
      .catch((err) => console.error("❌ Error fetching menus:", err));
  }, []);

  return (
    <div className="dashboard-container">
      {/* Always show Header */}
      <Header toggleSidebar={toggleSidebar} />

      <div className="dashboard-body">
        {/* Show Sidebar if open */}
        {isSidebarOpen && <Sidebar menuData={menuData} />}

        {/* Page-specific content */}
        <main className="dashboard-content">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
